module.exports = __webpack_public_path__ + "static/media/cognite-functions.485f2f5f.png";